import { PencilSimpleIcon } from "@phosphor-icons/react";
import { Button } from "@libertify/ui";

export type AddOnEditHeaderProps = {
  label: string;
  onEdit: () => void;
};

/**
 * "Edit {addon}" button — a deep link straight into that add-on's card in
 * the Edit page, distinct from the page header's own "Edit" CTA, which
 * always opens on General. The caller positions this as a floating button
 * (see `withAddOnEditHeader` in ExperiencePage.tsx) — this component only
 * owns the button itself.
 */
export const AddOnEditHeader = ({ label, onEdit }: AddOnEditHeaderProps) => (
  <Button
    variant="outlinedAccent"
    size="m"
    leftIcon={<PencilSimpleIcon />}
    iconSize={14}
    onClick={onEdit}
  >
    {label}
  </Button>
);
